export default __webpack_public_path__ + "static/media/s2.70dc7254.png";